const tr = {
  brand: {
    name: "OnHuman HR",
    short: "OnHuman",
    tagline: "İnsan Kaynakları Danışmanlığı",
  },
  nav: {
    home: "Ana Menü",
    about: "Hakkımda",
    services: "Hizmetlerim",
    contact: "İletişim",
    navigator: "Navigator",
    login: "Giriş",
    logout: "Çıkış Yap",
  },
  lang: { tr: "TR", en: "EN" },
  anamenu: {
    hero: {
      title: "Stratejik insan kaynakları ile geleceği inşa edin.",
      keyword: "geleceği",
      body: "OnHuman, modern İK çözümleriyle kurumların dönüşümüne liderlik eder. Yıllara dayanan tecrübeyle iş gücünüzü dönüştürmenize yardımcı oluyoruz.",
      primaryCta: "Danışmanlık Alın",
      secondaryCta: "Hizmetlerimiz",
    },
    capabilities: {
      eyebrow: "Ne Yapıyoruz",
      title: "Dört temel uzmanlık alanı.",
      items: [
        { n: "01", title: "İşe Alım Stratejisi", body: "İhtiyacınızı doğru tanımlayan, sektör dinamiklerini gözeten ve uzun vadeli uyum sağlayan işe alım çözümleri. Pozisyon analizinden referans kontrolüne kadar uçtan uca yönetim." },
        { n: "02", title: "Yönetici Arama", body: "Üst düzey pozisyonlar için gizli, hedefe yönelik aday değerlendirmesi. Yöneticilerinizin şirket kültürüne ve stratejik vizyonuna uyumu önceliğimizdir." },
        { n: "03", title: "Organizasyonel Gelişim", body: "Yapı, süreç ve kültür dönüşümü için danışmanlık. Performans yönetimi, kariyer haritalama ve yetkinlik modelleri ile sürdürülebilir bir iş gücü inşa edin." },
        { n: "04", title: "Aday Koçluğu", body: "Profesyonel kariyer planlaması, CV optimizasyonu ve mülakat hazırlığı. Adayların potansiyellerini doğru pozisyonlarda gerçekleştirmeleri için bireysel rehberlik." },
      ],
    },
    services: {
      eyebrow: "Hizmetlerimiz",
      title: "İşveren ve adaylar için iki ayrı yol.",
      cards: [
        { title: "İşveren Hizmetleri", body: "Pozisyon analizi, aday havuzu yönetimi, mülakat süreçleri ve yerleştirme sonrası takip. Şirketinizin büyüme hedeflerine yön veriyoruz.", href: "/isverenhizmetlerim", cta: "Detaylar" },
        { title: "Aday Hizmetleri", body: "Kariyer danışmanlığı, CV inceleme, mülakat koçluğu ve kişisel marka geliştirme. Hedefinize ulaşmanız için yanınızdayız.", href: "/adayhizmetlerim", cta: "Detaylar" },
      ],
    },
    cta: {
      title: "Bize Ulaşın",
      body: "Sorularınız ve iş birliği talepleriniz için bizimle iletişime geçin.",
      button: "İletişime Geçin",
      email: "contact@onhumanresources.com",
    },
  },
  // Structural labels for the record layout. These name parts of the page —
  // they carry no claims of their own.
  record: {
    details: "Bilgiler",
    related: "İlgili Sayfalar",
    location: "Konum",
    locationValue: "İstanbul · Türkiye",
    email: "E-posta",
    linkedin: "LinkedIn",
    onThisPage: "Bu Sayfada",
    channels: "İletişim Kanalları",
    writeToUs: "Bize Yazın",
    assistant: "Dijital Asistan",
  },
  pages: {
    hakkimda: {
      title: "Hakkımda",
      p1: "OnHuman, insan kaynakları alanında etik değerlere bağlı, çözüm odaklı ve yenilikçi bir vizyon sunar.",
      p2: "Danışmanlık süreçlerimizde karşılıklı güven, şeffaflık ve gizlilik önceliğimizdir. Her kurumun insan kaynağını daha güçlü, sürdürülebilir ve geleceğe hazır hale getirmeyi hedefleriz. Geleceğin iş dünyasında fark yaratmak için buradayız.",
    },
    hizmetler: {
      title: "Hizmetlerimiz",
      lede: "OnHuman olarak hem işverenlere hem de adaylara özel hizmetler sunuyoruz. Sizin için en doğru eşleşmeleri sağlıyoruz.",
      cards: [
        { title: "İşveren Hizmetlerimiz", body: "Doğru yetenekleri bulmak iş başarınızın anahtarıdır. Size özel işe alım stratejileri, aday değerlendirme çözümleri ve danışmanlık hizmetleri sunuyoruz.", href: "/isverenhizmetlerim", cta: "Detaylı Bilgi" },
        { title: "Aday Hizmetlerimiz", body: "Kariyerinizde bir sonraki adımı atmaya mı hazırsınız? CV danışmanlığı, mülakat hazırlığı ve iş eşleştirme desteğimizle yanınızdayız.", href: "/adayhizmetlerim", cta: "Detaylı Bilgi" },
      ],
      contactLead: {
        title: "Daha Fazla Bilgi Almak İster misiniz?",
        body: "İletişim formumuzu doldurarak size en kısa sürede dönüş yapmamızı sağlayabilirsiniz.",
      },
    },
    ilkeler: {
      title: "Çalışma İlkelerimiz",
      lede: "OnHuman olarak iş yapış şeklimizi değerlerimiz belirler. Sizi dinler, anlar ve en uygun çözümleri üretiriz.",
      values: [
        { title: "Güven ve Dürüstlük", body: "İş ilişkilerinde açık iletişim ve karşılıklı güven bizim temel taşımızdır. Tüm danışmanlık süreçlerinde şeffaflığı esas alırız." },
        { title: "Yenilikçilik", body: "Sürekli gelişen insan kaynakları dünyasında güncel kalmak için yeni teknolojilere ve yaklaşımlara açığız." },
        { title: "Gizlilik", body: "Müşterilerimizin ve adaylarımızın bilgileri bizim için gizlidir. Tüm süreçlerde veri güvenliğini ön planda tutarız." },
        { title: "İnsan Odaklılık", body: "İK'nın kalbinde insan vardır. Her bireyin potansiyelini en iyi şekilde ortaya çıkarmaya odaklanırız." },
      ],
      contactLead: {
        title: "İlkelerimizle Tanışmak İster misiniz?",
        body: "Bizimle iletişime geçerek süreçlerimiz hakkında daha fazla bilgi alın.",
      },
    },
  },
  forms: {
    contactBand: {
      title: ["Bizimle", "İletişime Geçin"],
      body: "Sorularınız için bizimle her zaman iletişime geçebilirsiniz. Vakit kaybetmeden Asistan HR'a da danışabilirsiniz.",
      button: "Asistan HR ile Soru Sor",
    },
    contact: {
      name: "Ad Soyad",
      email: "E-posta",
      message: "Mesajınızı girin...",
      send: "Gönder",
      sending: "Gönderiliyor...",
      fillAll: "Lütfen tüm alanları doldurun.",
      invalidEmail: "Geçerli bir e-posta adresi giriniz.",
      sent: "Mesaj başarıyla gönderildi!",
      failed: "Form gönderimi sırasında bir hata oluştu!",
    },
  },
  candidate: {
    title: "Aday Bilgileri",
    lede: "Başvurunuzu iletmek için lütfen aşağıdaki formu eksiksiz doldurun.",
    fullName: "Ad Soyad",
    fullNamePh: "Adınızı ve soyadınızı girin",
    email: "E-posta",
    emailPh: "ornek@mail.com",
    phone: "Telefon",
    phonePh: "5XXXXXXXXX",
    sectionEducation: "Eğitim & Yetenekler",
    sectionCv: "CV Yükleme",
    sectionKvkk: "KVKK",
    cvLabel: "CV Yükle",
    kvkkText: "KVKK Aydınlatma Metnini okudum ve kabul ediyorum.",
    kvkkRead: "Metni Oku",
    submit: "Başvuruyu Gönder",
    submitting: "Gönderiliyor...",
    success: "Başvurunuz başarıyla gönderildi! 🎉",
    failure: "Başvuru gönderimi sırasında hata oluştu!",
    errors: {
      fullName: "Ad Soyad zorunludur.",
      email: "Geçerli bir e-posta giriniz.",
      phone: "Geçerli bir telefon numarası giriniz.",
      education: "Eğitim durumunuzu belirtiniz.",
      cv: "CV yüklemek zorunludur.",
      kvkk: "KVKK onayını vermelisiniz.",
      cvType: "Sadece PDF, DOC veya DOCX dosyaları yükleyebilirsiniz.",
      cvSize: "Dosya boyutu 5MB'ı aşamaz.",
    },
    education: {
      label: "Eğitim Durumu",
      placeholder: "Seçiniz",
      options: [
        { value: "ortaokul", label: "Orta Okul" },
        { value: "lise", label: "Lise" },
        { value: "onlisans", label: "Önlisans" },
        { value: "lisans", label: "Lisans" },
        { value: "yukseklisans", label: "Yüksek Lisans" },
        { value: "doktora", label: "Doktora" },
      ],
    },
    skills: {
      label: "Yetenekler",
      placeholder: "Yetenek ekleyin ve virgüle basın...",
      hint: "Yetenekleri virgül veya Enter ile ekleyin, ✕ ile silin.",
    },
  },
  employer: {
    title: "İşveren Hizmetlerimiz",
    lede: "Talebinizi iletmek için lütfen aşağıdaki formu eksiksiz doldurun.",
    serviceLabel: "Hizmet Seçiniz",
    servicePlaceholder: "Bir hizmet seçiniz...",
    // `value` is the canonical name the API and the ?service= links use.
    services: [
      { value: "İşe alım ve Seçme-Yerleştirme Danışmanlığı", label: "İşe alım ve Seçme-Yerleştirme Danışmanlığı" },
      { value: "İnsan Kaynakları Süreçlerinin Yapılandırılması", label: "İnsan Kaynakları Süreçlerinin Yapılandırılması" },
      { value: "İK Mevzuatına Uygunluk ve Yasal Süreç Danışmanlığı", label: "İK Mevzuatına Uygunluk ve Yasal Süreç Danışmanlığı" },
      { value: "Organizasyonel Yapı ve Görev Tanımlarının Oluşturulması", label: "Organizasyonel Yapı ve Görev Tanımlarının Oluşturulması" },
      { value: "Eğitim ve Gelişim Programlarının Tasarımı", label: "Eğitim ve Gelişim Programlarının Tasarımı" },
      { value: "İş Hukuku Süreçlerinde Danışmanlık(Disiplin, Fesih, Uyarı)", label: "İş Hukuku Süreçlerinde Danışmanlık (Disiplin, Fesih, Uyarı)" },
    ],
    messageLabel: "Detaylı Talebiniz",
    messagePh: "Lütfen talebinizi detaylandırınız...",
    submit: "Talebi Gönder",
    submitting: "Gönderiliyor...",
    success: "Talebiniz başarıyla iletildi! 🎉",
    failure: "Talebiniz gönderilirken hata oluştu!",
    errors: {
      service: "Lütfen bir hizmet seçiniz.",
      message: "Lütfen talebinizi detaylandırınız.",
    },
  },
  login: {
    username: "Kullanıcı Adı",
    usernamePh: "Kullanıcı Adınız",
    password: "Şifre",
    remember: "Beni hatırla",
    submit: "Giriş Yap",
    submitting: "Giriş yapılıyor...",
    failed: "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.",
  },
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    p1: "OnHuman olarak kişisel verilerinizi 6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında işliyoruz. Kişisel verileriniz, yalnızca iş başvurunuzun değerlendirilmesi amacıyla alınacak ve bu amaç dışında kullanılmayacaktır.",
    p2: "Kişisel verilerinize ilişkin haklarınızı kullanmak için bizimle iletişime geçebilirsiniz. Detaylı bilgi için KVKK politikamıza göz atabilirsiniz.",
    p3: "Verileriniz yalnızca başvuru sürecinde yetkili kişiler tarafından erişilebilecek ve yasal yükümlülükler doğrultusunda işlenecektir.",
    close: "Kapat",
  },
  assistant: {
    eyebrow: "Dijital Asistan",
    title: "OnHuman Dijital Asistan",
    body: "Merak ettiklerinizi hızlıca sorun ve anında yanıt alın. Çalışma saatlerinden hizmet kapsamına kadar tüm detaylar elinizin altında.",
    panelTitle: "OnHuman Dijital Asistan",
    logLabel: "Sohbet geçmişi",
    inputLabel: "Bir soru yazın",
    placeholder: "Bir soru yazın...",
    send: "Gönder",
    faqTitle: "Sık Sorulanlar",
    greeting: "Merhaba! Size nasıl yardımcı olabilirim?",
  },
  dashboard: {
    tabs: {
      user: "İletişim Formu",
      employer: "İşveren Talepleri",
      candidate: "Aday Başvuruları",
    },
    columns: {
      user: ["Ad Soyad", "E-mail", "Mesaj", "Tarih"],
      employer: ["Hizmet", "Mesaj", "Tarih"],
      candidate: ["Ad Soyad", "E-mail", "Telefon", "Eğitim", "Yetenekler", "Tarih"],
    },
    all: "Tümü",
    title: "Talep Listesi",
    panel: "Panel",
    user: "Kullanıcı",
    category: "Kategori",
    detail: "Detay",
    noData: "Kayıt bulunamadı.",
    fields: {
      name: "Ad",
      email: "E-mail",
      message: "Mesaj",
      createdAt: "Tarih",
      service: "Servis",
      fullName: "Ad Soyad",
      phone: "Telefon",
      education: "Eğitim",
      skills: "Yetenekler",
    },
    rowsPerPage: "Sayfa başına satır",
    openDetails: "▼ Detayları Aç",
    closeDetails: "▲ Detayları Kapat",
  },
  footer: {
    desc: "Etik değerlere bağlı, çözüm odaklı ve yenilikçi insan kaynakları danışmanlığı.",
    rights: "Tüm hakları saklıdır.",
    contact: "İletişim",
    tech: "OnHuman Technology",
    principles: "Çalışma İlkelerim",
    backToTop: "Başa Dön",
  },
};
export default tr;
